export default __webpack_public_path__ + "static/media/target_default.f63d7b38.svg";